// GENERATED FILE, PLEASE DO NOT EDIT
export var ButtonGroupPaddingHorizontalLarge = 32;
export var ButtonGroupPaddingHorizontalMedium = 24;
export var ButtonGroupPaddingHorizontalSmall = 16;
export var ButtonGroupPaddingVerticalLarge = 32;
export var ButtonGroupPaddingVerticalMedium = 24;
export var ButtonGroupPaddingVerticalSmall = 16;
export var ButtonToggleGroupPaddingHorizontalLarge = 16;
export var ButtonToggleGroupPaddingHorizontalMedium = 12;
export var ButtonToggleGroupPaddingHorizontalSmall = 12;
export var ModalActionButtonsInline = 8;
export var NavBarPaddingHorizontalLarge = 32;
export var NavBarPaddingHorizontalMedium = 24;
export var NavBarPaddingHorizontalSmall = 16;
export var NavBarPaddingVerticalLarge = 32;
export var NavBarPaddingVerticalMedium = 24;
export var NavBarPaddingVerticalSmall = 16;
export var SmallPageMargin = 16;